import React, { useState } from "react";
import { MistyLogo } from "./ImageSlot";
import { Menu, X } from "lucide-react";

export const WarningBanner = () => (
  <div
    className="sticky top-0 z-[60] bg-white w-full border-b border-black/5"
    data-testid="warning-banner"
  >
    <div className="flex items-center justify-center gap-3 py-2 px-4">
      <span className="w-5 h-5 rounded-full bg-red-600 ring-2 ring-red-200 flex items-center justify-center text-white text-[9px] font-bold tracking-wide">
        18+
      </span>
      <p className="text-misty-base text-[10px] sm:text-xs tracking-[0.2em] uppercase font-sans font-semibold">
        You must be 18 years or older to use this website.
      </p>
    </div>
  </div>
);

export const Nav = () => {
  const [open, setOpen] = useState(false);

  const links = [
    { label: "About", href: "#about" },
    { label: "Products", href: "#products" },
    { label: "Orders", href: "#orders" },
    { label: "Contact", href: "#contact" },
  ];

  const handleClick = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      className="sticky top-[36px] z-[50] bg-misty-base/80 backdrop-blur-xl border-b border-white/5"
      data-testid="main-nav"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex justify-between items-center py-4">
        <a
          href="#hero"
          onClick={(e) => handleClick(e, "#hero")}
          data-testid="nav-logo"
        >
          <MistyLogo size="sm" />
        </a>
        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleClick(e, l.href)}
              className="text-misty-text/90 hover:text-misty-steel transition-colors text-xs tracking-[0.25em] uppercase font-sans"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </div>
        <button
          className="md:hidden text-misty-text"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/5 bg-misty-base/95 backdrop-blur-xl">
          <div className="flex flex-col py-2">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => handleClick(e, l.href)}
                className="px-6 py-3 text-misty-text/90 hover:text-misty-steel transition-colors text-xs tracking-[0.25em] uppercase"
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};
